import { CertificateType } from '../certificates/reducers';
import {
    ADD_CERTIFICATES_TAB,
    ADD_CERTIFICATES_TAB_FAILED,
    ADD_CERTIFICATES_TAB_SUCCESS,
    GET_CERTIFICATES_TAB,
    GET_CERTIFICATES_TAB_FAILED,
    GET_CERTIFICATES_TAB_SUCCESS,
} from './actions';

export interface CountType {
    ALL: number;
    ACTIVE: number;
    INACTIVE: number;
    DELETED: number;
}

export interface CertifcatesTabInitialState {
    certificatesData: CertificateType[];
    certificate: CertificateType;
    certificateTabData: [];
    pageCount: number;
    count: CountType;
    isLoading: boolean;
    certificateByIdLoading: boolean;
    certificateByIdError: string | null;
    certificatesError: string | null;
    createChallengeError: string | null;
    certificateCreateSuccessMessage: string | null;
    isDeleteLoading: boolean;
    deleteChallengeError: string | null;
    certificateDeleteSuccessMessage: string | null;
    isCreateLoading: boolean;
    isEditLoading: boolean;
    editChallengeError: string | null;
    certificateUpdateSuccessMessage: string | null;
    isAddMaterialLoading: boolean;
    materialError: string | null;
    materialSuccessMessage: string | null;
    isBulkUpdateLoading: boolean;
    bulkError: string | null;
    certificateBulkSuccessMessage: string | null;
}

const initialState: CertifcatesTabInitialState = {
    certificatesData: [],
    certificate: null,
    certificateTabData: [],
    pageCount: null,
    count: null,
    isLoading: false,
    certificateByIdLoading: false,
    certificateByIdError: null,
    certificatesError: null,
    createChallengeError: null,
    certificateCreateSuccessMessage: null,
    isDeleteLoading: false,
    deleteChallengeError: null,
    certificateDeleteSuccessMessage: null,
    isCreateLoading: false,
    isEditLoading: false,
    editChallengeError: null,
    certificateUpdateSuccessMessage: null,
    isAddMaterialLoading: false,
    materialError: null,
    materialSuccessMessage: null,
    isBulkUpdateLoading: null,
    bulkError: null,
    certificateBulkSuccessMessage: null,
};

const certificatesTabReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case ADD_CERTIFICATES_TAB:
            return { ...state, isLoading: true, trackError: null };
        case ADD_CERTIFICATES_TAB_SUCCESS:
            return {
                ...state,
                isLoading: false,
                certificatesData: action.payload,
                pageCount: action.payload.totalPages,
            };
        case ADD_CERTIFICATES_TAB_FAILED:
            return { ...state, isLoading: false, trackError: action.payload };
        case GET_CERTIFICATES_TAB:
            return { ...state, isLoading: true, trackError: null };
        case GET_CERTIFICATES_TAB_SUCCESS:
            return {
                ...state,
                isLoading: false,
                count: action.payload.counts,
                certificateTabData: action.payload,
                pageCount: action.payload.totalPages,
            };
        case GET_CERTIFICATES_TAB_FAILED:
            return { ...state, isLoading: false, trackError: action.payload };
        default:
            return state;
    }
};

export default certificatesTabReducer;
